if (!customElements.get("product-markers")) {
  customElements.define(
    "product-markers",
    class ProductMarkers extends HTMLElement {
      connectedCallback() {
        this.points = Array.from(this.querySelectorAll("[data-marker-point]"));
        this.cards = Array.from(this.querySelectorAll("[data-marker-card]"));

        if (!this.points.length) return;

        this.onPointClick = this.handlePointClick.bind(this);
        this.onDocumentClick = this.handleDocumentClick.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);
        this.onBlockSelect = this.handleBlockSelect.bind(this);
        this.onBlockDeselect = this.handleBlockDeselect.bind(this);

        this.points.forEach((point) => {
          point.addEventListener("click", this.onPointClick);
        });

        document.addEventListener("click", this.onDocumentClick);
        this.addEventListener("keydown", this.onKeydown);
        document.addEventListener("shopify:block:select", this.onBlockSelect);
        document.addEventListener(
          "shopify:block:deselect",
          this.onBlockDeselect
        );
      }

      disconnectedCallback() {
        if (!this.points || !this.points.length) return;

        this.points.forEach((point) => {
          point.removeEventListener("click", this.onPointClick);
        });

        document.removeEventListener("click", this.onDocumentClick);
        this.removeEventListener("keydown", this.onKeydown);
        document.removeEventListener(
          "shopify:block:select",
          this.onBlockSelect
        );
        document.removeEventListener(
          "shopify:block:deselect",
          this.onBlockDeselect
        );
      }

      handlePointClick(event) {
        const point = event.currentTarget;
        const wasActive = point.classList.contains("is-active");

        this.closeAll();

        if (!wasActive) this.open(point.dataset.markerPoint);
      }

      handleDocumentClick(event) {
        const target = event.target;

        if (!target || typeof target.closest !== "function") return;

        // Only a marker of this section (its own handler does the toggling) or
        // a click inside one of its open cards keeps the card open. Everything
        // else closes it, including the image around the markers.
        const point = target.closest("[data-marker-point]");
        const card = target.closest("[data-marker-card]");

        if (point && this.contains(point)) return;
        if (card && this.contains(card)) return;

        this.closeAll();
      }

      handleKeydown(event) {
        if (event.key !== "Escape") return;

        const activePoint = this.querySelector("[data-marker-point].is-active");

        this.closeAll();

        if (activePoint) activePoint.focus();
      }

      handleBlockSelect(event) {
        const point = this.getPointFromEvent(event);

        if (!point) return;

        this.closeAll();
        this.open(point.dataset.markerPoint);
      }

      handleBlockDeselect(event) {
        if (!this.getPointFromEvent(event)) return;

        this.closeAll();
      }

      getPointFromEvent(event) {
        if (!event.target || typeof event.target.closest !== "function") {
          return null;
        }

        const point = event.target.closest("[data-marker-point]");

        return point && this.contains(point) ? point : null;
      }

      open(index) {
        const point = this.points.find(
          (item) => item.dataset.markerPoint === index
        );
        const card = this.cards.find(
          (item) => item.dataset.markerCard === index
        );

        if (point) {
          point.classList.add("is-active");
          point.setAttribute("aria-expanded", "true");
        }

        if (card) card.classList.add("is-active");
      }

      closeAll() {
        this.points.forEach((point) => {
          point.classList.remove("is-active");
          point.setAttribute("aria-expanded", "false");
        });

        this.cards.forEach((card) => card.classList.remove("is-active"));
      }
    }
  );
}
